import { render, staticRenderFns } from "./PdfHeader.vue?vue&type=template&id=a8608272&scoped=true"
import script from "./PdfHeader.vue?vue&type=script&lang=js"
export * from "./PdfHeader.vue?vue&type=script&lang=js"
import style0 from "./PdfHeader.vue?vue&type=style&index=0&id=a8608272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8608272",
  null
  
)

export default component.exports